import Tooltip from '@components/Tooltip';
import { useTranslation } from 'react-i18next';

function RecentToolTip() {
    const { t } = useTranslation('signIn');
    return (
        <Tooltip visibleKey='signInMethod'
            shape='line'
            hideClose
            top={-36}
            right={0} >
            {t('recentLogin')}
        </Tooltip>
    );
}

export default RecentToolTip;
